'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Topic2) {
  Topic2[Topic2["WSOpen"] = 0] = "WSOpen";
  Topic2[Topic2["WSError"] = 1] = "WSError";
  Topic2[Topic2["WSClose"] = 2] = "WSClose";
  Topic2[Topic2["BalanceChanged"] = 3] = "BalanceChanged";
  Topic2[Topic2["WithdrawStatusChanged"] = 4] = "WithdrawStatusChanged";
  Topic2[Topic2["UserDataRequired"] = 5] = "UserDataRequired";
  Topic2[Topic2["KYCStatusUpdated"] = 6] = "KYCStatusUpdated";
  Topic2[Topic2["SessionChanged"] = 7] = "SessionChanged";
  Topic2[Topic2["SessionCreated"] = 8] = "SessionCreated";
  Topic2[Topic2["SessionDestroyed"] = 9] = "SessionDestroyed";
  Topic2[Topic2["SessionExpired"] = 10] = "SessionExpired";
  Topic2[Topic2["SessionKickedOut"] = 11] = "SessionKickedOut";
  Topic2[Topic2["SessionLimitationTimeReached"] = 12] = "SessionLimitationTimeReached";
  Topic2[Topic2["SessionSelfExclusion"] = 13] = "SessionSelfExclusion";
  Topic2[Topic2["SessionLoggedOut"] = 14] = "SessionLoggedOut";
  Topic2[Topic2["SessionGeoLocation"] = 15] = "SessionGeoLocation";
  Topic2[Topic2["CategoriesPublished"] = 16] = "CategoriesPublished";
  Topic2[Topic2["TranslationsPublished"] = 17] = "TranslationsPublished";
  Topic2[Topic2["UserUpdated"] = 18] = "UserUpdated";
  Topic2[Topic2["MaintenanceChanged"] = 19] = "MaintenanceChanged";
  Topic2[Topic2["AchievementUnlocked"] = 20] = "AchievementUnlocked";
  Topic2[Topic2["FirstDeposit"] = 21] = "FirstDeposit";
  Topic2[Topic2["SubsequentDeposit"] = 22] = "SubsequentDeposit";
  Topic2[Topic2["RewardReceived"] = 23] = "RewardReceived";
  Topic2[Topic2["RelicPrizeAwarded"] = 24] = "RelicPrizeAwarded";
  Topic2[Topic2["LeaderboardPayout"] = 25] = "LeaderboardPayout";
  Topic2[Topic2["DelayedReward"] = 26] = "DelayedReward";
  Topic2[Topic2["Message"] = 27] = "Message";
  Topic2[Topic2["SOWQRequested"] = 28] = "SOWQRequested";
  Topic2[Topic2["UserBlockStatus"] = 29] = "UserBlockStatus";
  Topic2[Topic2["LoyaltyPointsUpdate"] = 30] = "LoyaltyPointsUpdate";
  Topic2[Topic2["GameSessionSummary"] = 31] = "GameSessionSummary";
  Topic2[Topic2["LotbaUserSelfExcludedOnOldRegister"] = 32] = "LotbaUserSelfExcludedOnOldRegister";
  Topic2[Topic2["GameTransaction"] = 33] = "GameTransaction";
})(exports.Topic || (exports.Topic = {}));
class PubSub {
  constructor() {
    this.id = 0;
    this.topics = {};
  }
  subscribe(topic, handler) {
    if (!this.topics[topic]) {
      this.topics[topic] = [];
    }
    const id = (++this.id).toString();
    const unsub = () => this.unsubscribe(id);
    this.topics[topic].push({ id, handler });
    return { id, unsub };
  }
  publish(topic, params) {
    if (!this.topics[topic]) {
      return false;
    }
    this.topics[topic].forEach((subscriber) => {
      subscriber.handler(params);
    });
    return true;
  }
  unsubscribe(id) {
    for (const key in this.topics) {
      if (!this.topics.hasOwnProperty(key)) {
        continue;
      }
      const topic = key;
      if (Array.isArray(this.topics[topic])) {
        for (let i = 0; i < this.topics[topic].length; i++) {
          if (this.topics[topic][i].id === id) {
            this.topics[topic].splice(i, 1);
            return true;
          }
        }
      }
    }
    return false;
  }
}
const pubsub = new PubSub();

exports.pubsub = pubsub;
